<ion-header class="ion-no-border"> 
  <ion-toolbar>
    <ion-buttons slot="start">
      <smr-menu-button></smr-menu-button>
    </ion-buttons>
    <ion-title>
      Email Marketing
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>

  <ion-buttons class="tab-group">
    <ion-button [ngClass]="{ 'tab-checked': tab == 'marketing-composer' }" class="tab-button" (click)="tab = 'marketing-composer'">Send</ion-button>
    <ion-button [ngClass]="{ 'tab-checked': tab == 'marketing-history' }"  class="tab-button" (click)="tab = 'marketing-history'">History</ion-button>
  </ion-buttons>

  <ion-row>
    <ion-col class="hidden-sm-down"></ion-col>

    <ion-col size="12" size-sm="12" size-md="8" size-lg="8" size-xl="8">

      <div [ngSwitch]="tab">
        <smr-marketing-composer *ngSwitchCase="'marketing-composer'"></smr-marketing-composer>
        <smr-marketing-history-list *ngSwitchCase="'marketing-history'"></smr-marketing-history-list>
      </div>
    </ion-col>

    <ion-col class="hidden-sm-down"></ion-col>
  </ion-row>
</ion-content>
